const TENANT_SELECTION_COOKIE = "preezie_selected_tenant";

export const getRememberedTenantId = () => {
  if (typeof document === "undefined") return "";

  const cookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${TENANT_SELECTION_COOKIE}=`));

  if (!cookie) return "";

  const value = cookie.split("=")[1] || "";
  return decodeURIComponent(value);
};

export const rememberTenantId = (tenantId) => {
  if (typeof document === "undefined") return;

  if (!tenantId) {
    clearRememberedTenantId();
    return;
  }

  document.cookie = `${TENANT_SELECTION_COOKIE}=${encodeURIComponent(tenantId)}; path=/; SameSite=Lax`;
};

export const clearRememberedTenantId = () => {
  if (typeof document === "undefined") return;

  document.cookie = `${TENANT_SELECTION_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
};
